import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { 
    withStyles,
    Grid,
    TextField,
  } from '@material-ui/core';
import '../../../scss/component/onboarding/company_profile.scss'
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const useStyles = (theme) => ({
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
    },
    input: {
        width: '100%',
    }
  });

class CompanyProfileStepOne extends PureComponent{
    constructor (props) {
        super(props)
        this._isMounted = false;
        this.state = {
        };

      }

    industryOptions = [
        { value: 'Accommodation and Food Services', label: 'Accommodation and Food Services' },
        { value: 'Administrative and Support and Waste Management and Remediation Services', label: 'Administrative and Support and Waste Management and Remediation Services' },
        { value: 'Agriculture, Forestry, Fishing and Hunting', label: 'Agriculture, Forestry, Fishing and Hunting' },
        { value: 'Arts, Entertainment and Recreation', label: 'Arts, Entertainment and Recreation' },
        { value: 'Construction', label: 'Construction' },
        { value: 'Educational Services', label: 'Educational Services' },
        { value: 'Finance and Insurance', label: 'Finance and Insurance' },
        { value: 'Health Care and Social Assistance', label: 'Health Care and Social Assistance' },
        { value: 'Management of Companies and Enterprises', label: 'Management of Companies and Enterprises' },
        { value: 'Manufacturing', label: 'Manufacturing' },
        { value: 'Mining', label: 'Mining' },
        { value: 'Professional, Scientific, and Technical Services', label: 'Professional, Scientific, and Technical Services' },
        { value: 'Public Administration', label: 'Public Administration' },
        { value: 'Real Estate Rental and Leasing', label: 'Real Estate Rental and Leasing' },
        { value: 'Retail Trade', label: 'Retail Trade' },
        { value: 'Transportation and Warehousing', label: 'Transportation and Warehousing' },
        { value: 'Utilities', label: 'Utilities' },
        { value: 'Wholesale Trade', label: 'Wholesale Trade' },
        { value: 'Other Services (except Public Administration)', label: 'Other Services (except Public Administration)' },
    ]

    numWorkersOptions = [
        { value: '1-10 employees', label: '1-10 employees' },
        { value: '11-50 employees', label: '11-50 employees' },
        { value: '51-200 employees', label: '51-200 employees' },
        { value: '201-500 employees', label: '201-500 employees' },
        { value: '501-1000 employees', label: '501-1000 employees' },
        { value: '1001-5000 employees', label: '1001-5000 employees' },
        { value: '5001-10,000 employees', label: '5001-10,000 employees' },
        { value: '10,000+ employees', label: '10,000+ employees' },
    ]

    render(){
        const { classes,
                saveLocation,
                saveYears,
                saveIndustry,
                saveWorkers,
                saveRevenue,
                companyLocation,
                companyYears,
                companyNumWorkers,
                companyIndustry,
                companyRevenue
            } = this.props;
        return(
            <div>
                <div id="form_title">
                    <h3>Step 1: Tell us a bit about your business</h3>
                    <span>We won't share this information with anyone. For more details, see our privacy and security policy</span><br/>
                </div>
                <div className="form_container">
                    <form>
                            <label>Where is your company located?</label><br/>
                            <TextField
                                variant="outlined"
                                placeholder="Enter Street, City, State and ZIP"
                                defaultValue={companyLocation}
                                className={classes.input}
                                onChange={(event)=>{
                                    saveLocation(event.target.value)
                                }}
                            /><br/><br/>
                        <Grid container spacing={2}>
                            <Grid item md={6} id="left_grid_step1">
                                <label>What industry are you in?</label>
                                <Autocomplete
                                    options={this.industryOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (companyIndustry === undefined || companyIndustry === ""){
                                            return {value:"",label:""}
                                        }
                                        else{
                                            return({value:companyIndustry,label:companyIndustry})
                                        }
                                    }}
                                    popupIcon={<KeyboardArrowDownIcon/>}
                                    onInputChange={(event,value)=>{
                                        saveIndustry(value)
                                    }}
                                    renderInput={(params) => {
                                    return(<TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select an option"
                                    />
                                    );}}
                                    /><br/>
                                <label>What's your annual revenue?</label><br/>
                                <TextField
                                        type="number"
                                        variant="outlined"
                                        placeholder="Enter an approximate value"
                                        defaultValue={companyRevenue}
                                        className={classes.input}
                                        onChange={(event)=>{saveRevenue(event.target.value)}}
                                />
                            </Grid>
                            <Grid item md={6} id="right_grid_step1">
                                <label>How long have you been in business?</label><br/>
                                <TextField
                                        type="number"
                                        variant="outlined"
                                        placeholder="# of years"
                                        className={classes.input}
                                        defaultValue={companyYears}
                                        onChange={(event)=>{saveYears(event.target.value)}}
                                /><br/><br/>

                                <label>How many people work at your company?</label><br/>
                                <Autocomplete
                                    options={this.numWorkersOptions}
                                    getOptionLabel={(option) => option.label}
                                    defaultValue={()=>{
                                        if (companyNumWorkers === undefined || companyNumWorkers === ""){
                                            return {value:"",label:""}
                                        }
                                        else{
                                            return({value:companyNumWorkers,label:companyNumWorkers})
                                        }
                                    }}
                                    popupIcon={<KeyboardArrowDownIcon/>}
                                    onInputChange={(event,value)=>{
                                        saveWorkers(value)
                                    }}
                                    renderInput={(params) => {
                                    return(<TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select an option"
                                    />
                                    );}}
                                    /><br/>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        )
    }

}

export default withRouter(withApollo((withStyles(useStyles)(CompanyProfileStepOne))))


// WEBPACK FOOTER //
// ./src/components/onboarding/components/CompanyProfileStepOne.js